export default __webpack_public_path__ + "static/media/Frame 1.48eff66d.svg";